import { render } from "./DataGovernanceArticles.vue?vue&type=template&id=5797f5fd&scoped=true"
import script from "./DataGovernanceArticles.vue?vue&type=script&lang=js"
export * from "./DataGovernanceArticles.vue?vue&type=script&lang=js"

import "./DataGovernanceArticles.vue?vue&type=style&index=0&id=5797f5fd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5797f5fd"]])

export default __exports__